import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalPernyataan() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnChangeEmail = (e) =>{
    console.log(e.target.value)
  }

  return (
    <div>
      <Button variant="outlined" color="primary" 
        startIcon={<VisibilityIcon />}
        style={{textTransform: 'none', float: 'right'}} onClick={handleClickOpen}>
        Lupa Password ?
      </Button>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{"Silahkan masukkan email sekolah anda"}</DialogTitle>
          <DialogContent>
              <form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      id="emailConfirm"
                      type="email"
                      label="Email Sekolah Anda"
                      onChange={handleOnChangeEmail}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <DialogContentText id="alert-dialog-slide-description">
                      Kami akan mengirimkan link untuk melakukan reset password di email anda
                    </DialogContentText>
                  </Grid>

                  <Grid item xs={12}>
                    <Button variant="outlined" onClick={handleClose} color="secondary" style={{textTransform: 'none'}}>
                      Batal
                    </Button>
                    <Button variant="outlined" type="submit" color="primary" style={{float: 'right', textTransform: 'none'}}>
                      Kirim
                    </Button>
                  </Grid>
                </Grid>
                

            
              </form>
              
          </DialogContent>
        </Dialog>
    </div>
  );
}
